import { FC } from "react";

export const BackToTop: FC = () => (
  <a href="#top" className="back-to-top">
    <i className="lni lni-chevron-up"></i>
  </a>
);
